module.exports = __webpack_public_path__ + "static/images/cross-small.2bb4b2e73e2366b28a60d8bea2d74349.svg";